import Alt from 'alt'

const alt = new Alt()

Alt.debug('alt', alt)
window.alt = alt

module.exports = alt



// WEBPACK FOOTER //
// ./src/alt.js